import { format, isValid, parseISO } from "date-fns";

export function nowDeliveryParts(): { date: string; time: string } {
  const now = new Date();
  return {
    date: format(now, "yyyy-MM-dd"),
    time: format(now, "HH:mm"),
  };
}

export function parseDeliveryParts(raw: string | null | undefined): { date: string; time: string } {
  if (raw) {
    const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
    const d = parseISO(normalized);
    if (isValid(d)) {
      return {
        date: format(d, "yyyy-MM-dd"),
        time: format(d, "HH:mm"),
      };
    }
  }
  return nowDeliveryParts();
}

/** Builds `Y-m-d H:i:s` for the API from date + HH:mm parts. */
export function formatDeliveryPayload(date: string, time: string): string | null {
  const d = date.trim();
  const t = time.trim();
  if (!d || !t) return null;
  const hhmm = /^\d{1,2}:\d{2}$/.test(t) ? t : null;
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":");
  return `${d} ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
}
